<template>
    <el-dialog
        title="采集商品信息"
        :visible="dialogVisible"
        v-loading="loading"
        width="500px"
        :show-close="false">

        <el-tabs tab-position="left" style="height: 200px;">
            <el-tab-pane label="京东">
                <div class="import-box">
                    <div class="import-input">
                        <el-input clearable v-model="url" ></el-input>
                        <el-button type="primary" style="margin-left: 10px" @click="getProductDetails()" placeholder="请输入京东的商品页URL">采 集</el-button>
                    </div>
                    <div class="illustrate">
                        <h3>说明：</h3>
                        <p>
                            在京东商城找到需要采集的商品，将浏览器URL（例：https://item.jd.com/465467479.html）复制到文本框内，点击采集。
                            获取成功后自动添加到，商品名称、商品主图、商品详情。
                        </p>
                    </div>
                </div>
            </el-tab-pane>
<!--            <el-tab-pane label="淘宝">-->
<!--                <div class="import-box">-->
<!--                    <h3>说明：</h3>-->
<!--                </div>-->
<!--            </el-tab-pane>-->
<!--            <el-tab-pane label="得物">-->
<!--                <div class="import-box">-->
<!--                    <h3>说明：</h3>-->
<!--                </div>-->
<!--            </el-tab-pane>-->
<!--            <el-tab-pane label="拼多">-->
<!--                <div class="import-box">-->
<!--                    <h3>说明：</h3>-->
<!--                </div>-->
<!--            </el-tab-pane>-->
        </el-tabs>

        <span slot="footer" class="dialog-footer">
            <el-button @click="close">关 闭</el-button>
<!--            <el-button type="primary" @click="dialogVisible = false">确 定</el-button>-->
        </span>
    </el-dialog>
</template>

<script>
import { get } from '@/utils/request.js';
import { f } from 'vue-print-nb/lib/print.common';
export default {
    data() {
        return {
            dialogVisible: false,
            loading: false,
            url: "",
        };
    },
    methods:{
        // 显示组件
        show(){
            this.dialogVisible = true;
            this.url = "";
        },

        // 关闭组件
        close(){
            this.dialogVisible = false;
        },

        // 点击获取
        getProductDetails(){
            this.loading = true
            get('/garb/info/getJingDongProduct', {
                url: this.url,
            }).then((res)=>{
                this.loading = false
                if(res.success){
                    this.$message.success(res.msg);
                    this.$emit("getProductDetails",res.grabJingDongProduct)
                } else {
                    this.$message.error(res.msg);
                }
            })
        }
    }
};
</script>

<style scoped lang="scss">
    .import-box{
        width: 400px;
        height: 200px;
        overflow: hidden;

        .import-input{
            display: flex;
        }

        .illustrate{
            padding-top: 10px;

            p{
                text-indent:2em
            }
        }
    }
</style>